import { render } from "./RoomCard.vue?vue&type=template&id=7d059ea3"
import script from "./RoomCard.vue?vue&type=script&lang=ts"
export * from "./RoomCard.vue?vue&type=script&lang=ts"
script.render = render

export default script